"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = require("babel-runtime/core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

exports.get = get;
exports.set = set;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function get(name) {
    return new _promise2.default(function (resolve) {
        resolve(window.localStorage.getItem(name));
    });
}

function set(name, val) {
    return new _promise2.default(function (resolve) {
        resolve(window.localStorage.setItem(name, val));
    });
}


//////////////////
// WEBPACK FOOTER
// ./src/libs/storage/Local.js
// module id = 3GM/
// module chunks = 1